// extracted by mini-css-extract-plugin
export default {"main":"Main_main__SqrVH","select":"Main_select__zUJs1","inputs":"Main_inputs__3vsQj","text":"Main_text__cXP-d","btn":"Main_btn__ra-SH","errorText":"Main_errorText__NDy9x"};